import type { TFunction } from 'i18next'
import { getApiErrorCode } from './apiError'
import { DEFAULT_RESEND_COOLDOWN_SECONDS } from '@/hooks/useResendCooldown'

export function isRecoveryDailyRateLimit(error: unknown): boolean {
  const message =
    (error as { response?: { data?: { error?: { message?: string } } } })?.response?.data?.error
      ?.message ?? ''
  return /daily limit/i.test(message)
}

export function isRecoveryRateLimited(error: unknown): boolean {
  return getApiErrorCode(error) === 'RATE_LIMITED'
}

export function getRecoveryRateLimitCooldownSeconds(error: unknown): number | null {
  if (!isRecoveryRateLimited(error)) return null
  if (isRecoveryDailyRateLimit(error)) return null
  return DEFAULT_RESEND_COOLDOWN_SECONDS
}

export function getRecoveryRateLimitMessage(error: unknown, t: TFunction): string | null {
  if (!isRecoveryRateLimited(error)) return null
  if (isRecoveryDailyRateLimit(error)) {
    return t('apiError.DAILY_LIMIT_EXCEEDED', { ns: 'common' })
  }
  return t('apiError.RATE_LIMITED', { ns: 'common' })
}
